import { IGatsbyImageData } from "gatsby-plugin-image"
import styled, { css } from "styled-components"

import InnerWrapper from "components/InnerWrapper"
import LazyVideo from "components/LazyLoadedVideo"
import ZoomImageGatsby from "components/UI-Related/ZoomImageGatsby"
import colors from "styles/colors"
import { fmobile, fresponsive, ftablet } from "utils/fullyResponsive"
import useMedia from "utils/useMedia"

interface Props {
  children: React.ReactNode
  bgColor?: string
  sectionHeight?: string
  imgHeight?: string
  imgWidth?: string
  objectFit?: string
  left?: string
  top?: string
  topVideo?: string
  noBackground? : boolean | undefined
}

interface PropsWithImage extends Props {
  img?: IGatsbyImageData | undefined
  video?: never
}

interface PropsWithVideo extends Props {
  video?: string | string[]
  img?: never
}

export default function BottomCallout({
  children = null,
  img,
  imgHeight = "",
  imgWidth = "",
  sectionHeight = "",
  bgColor = "",
  objectFit = "cover",
  left = "",
  top = "",
  video = "",
  topVideo = "",
  noBackground,
}: PropsWithImage | PropsWithVideo) {
  const videoCombined = typeof video === "string" ? [video] : video
  
  return (
    <Wrapper sectionHeight={sectionHeight} bgColor={bgColor}>
      <Curve noBackground={noBackground} left={left} top={top}>
        {video !== "" ? (
          <>
            {video} <Video topVideo={topVideo} className="bottomVideo" src={videoCombined} />
          </>
        ) : (
          <ZoomImageGatsby
            className="bottomCallout"
            alt="frontierImg"
            src={img}
            objectFit={objectFit}
            width={imgWidth || "100%"}
            height={imgHeight || "100%"}
          />
        )}
      </Curve>
      <InnerWrapper largerMargins={useMedia(true, true, false, false)}>
        {children}
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ bgColor?: string; sectionHeight: string }>`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ bgColor }) => bgColor ?? `${colors.lightMode}`};
  will-change: transform;
  transform: translate3d(0, 0, 0, 0);
  

  ${fresponsive(css`
    padding: 100px 0 560px;
    overflow: hidden;
  `)}

  ${ftablet(css`
    padding-bottom: 280px;
    overflow: hidden;
  `)}

  ${fmobile(css`
    padding: 80px 0 525px;
  `)}


  height: ${({ sectionHeight }) => sectionHeight || "initial"};
`

const Curve = styled.div<{ noBackground?: boolean; left?: string; top?: string }>`
  background-color: ${({ noBackground }) => (noBackground ? "transparent" : colors.darkMode)};
  background: ${({ noBackground }) => (noBackground ? "transparent" : colors.darkMode)};
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  top: ${({ top }) => top || "0"};
  left: ${({ left }) => left || "0"};
  z-index: -1;
  overflow: hidden !important;

  ${fresponsive(css`
    border-radius: 415px 0 0 0;
    background-size: 1660px 1411px;
  `)}

  ${ftablet(css`
    border-radius: 200px 0px 0px 0px;
    background-size: 1536px 973px;
  `)}

  ${fmobile(css`
    border-radius: 100px 0px 0px 0px;
    background-size: cover;
    background-position: center 248px;
  `)}
`

const Video = styled(LazyVideo)<{ topVideo?: string }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: ${({ topVideo }) => topVideo || "0"};
`
